import { Button, CircularProgress, Dialog, DialogContent } from '@mui/material'
import React from 'react'
import { CalQtySack } from '../services/stockService'

export default function ConfirmDialogReceive({ open, setOpen, rows, handleAdd, loadingSubmit }) {
    console.log(rows);
    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            fullWidth
            maxWidth='xl'
        >
            <DialogContent>
                <div class="d-flex row align-items-center mb-4">
                    <div class="col-12">
                        <label style={{
                            fontSize: '1.5rem',
                            fontWeight: '700',
                            color: '#3364af',
                        }}>
                            รายการรับเมล็ดพันธุ์ {/* {{data?.header}} */}
                        </label>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 table-responsive-sm ">
                        <table class="table table-borderless  ">
                            <thead>
                                <tr>
                                    <th scope="col " class="text-center">ที่</th>
                                    <th scope="col " class="text-center">เมล็ดพันธุ์</th>
                                    <th scope="col " class="text-center">ชั้นพันธุ์</th>

                                    <th scope="col " class="text-center">ฤดู</th>
                                    <th scope="col " class="text-center">ชนิดข้าว </th>
                                    <th scope="col " class="text-center">สารเคมี </th>
                                    <th scope="col " class="text-center"> ปีที่ผลิต</th>

                                    <th scope="col " class="text-center">ล็อตที่</th>
                                    <th scope="col " class="text-center">จำนวน (กระสอบ)</th>
                                    <th scope="col " class="text-center">ปริมาณ</th>
                                    <th scope="col " class="text-center">หน่วย</th>
                                    <th scope="col " class="text-center">โรงเก็บที่</th>
                                    <th scope="col " class="text-center">ราคาจำหน่าย</th>
                                    <th scope="col " class="text-center">ต้นทุนการผลิต</th>
                                </tr>
                            </thead>
                            <tbody class="">
                                {rows?.map((creds, i) => (
                                    <tr>
                                        <td class="text-center">{i + 1}.</td>
                                        <td class="text-center">{creds?.ItemNo?.ItemName}</td>
                                        <td class="text-center">{creds?.ItemNo?.Option2}</td>
                                        <td class="text-center">
                                            <span style={{ fontWeight: 'bold', 'color': creds?.Season === 'ฝน' ? '#0D9206' : 'brown' }}>{creds?.ItemNo?.Season} </span>
                                        </td>
                                        <td class="text-center">{creds?.ItemNo?.Option1}</td>
                                        <td class="text-center">{creds?.ItemNo?.Chemical}</td>
                                        <td class="text-center">{creds?.Year}</td>
                                        <td class="text-center">{creds?.LotGen}{creds?.Lot}</td>
                                        <td class="text-center">{CalQtySack(creds?.ItemNo?.Option2, creds.Qty.toString().replaceAll(',', ''))}</td>
                                        <td class="text-center">{creds?.Qty}</td>
                                        <td class="text-center">{creds?.ItemNo?.UnitNo?.UnitName || creds?.UnitNo?.UnitName}</td>
                                        <td class="text-center">{creds?.WarehouseName || creds?.WarehouseNo?.WarehouseName} {creds?.ZoneNo?.ZoneName}</td>
                                        <td class="text-center">{creds?.ItemNo?.SalePrice}</td>
                                        <td class="text-center">{creds?.CostPrice.toLocaleString()}</td>
                                    </tr>))}
                            </tbody>
                        </table>
                    </div>


                </div>
                <div class="row mt-4">

                    <div class="col-12 text-end">
                        <Button onClick={() => setOpen(false)} variant='outlined' sx={{ width: "150px", marginRight: '20px' }}>ยกเลิก</Button>
                        <Button disabled={loadingSubmit} onClick={() => handleAdd()} variant='contained' sx={{ width: "150px", marginRight: '20px' }}>{loadingSubmit ? <CircularProgress size={'24px'} color="inherit" /> : 'ยืนยันการทำรายการ'}</Button>

                    </div>
                </div >
            </DialogContent >
        </Dialog >
    )
}
